import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/typeabsensi";
var post = "/typeabsensi";
export const actGetDataTypeabsensi = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_TYPEABSENSI" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEABSENSI",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_TYPEABSENSI", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEABSENSI",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataTypeabsensi = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_TYPEABSENSI" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type attendence has been created");
          dispatch(
            __openModal({ modal: "MODAL_ADD_TYPEABSENSI", open: false })
          );
          return dispatch(actGetDataTypeabsensi());
        }
        return dispatch({ type: "ERROR_TYPEABSENSI", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEABSENSI",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataTypeabsensi = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_TYPEABSENSI" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type attendence has been updated");
          dispatch(
            __openModal({ modal: "MODAL_EDIT_TYPEABSENSI", open: false })
          );
          return dispatch(actGetDataTypeabsensi());
        }
        return dispatch({ type: "ERROR_TYPEABSENSI", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEABSENSI",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataTypeabsensi = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_TYPEABSENSI" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEABSENSI",
            message: "Success get data",
          });
        }
        return dispatch({ type: "ERROR_TYPEABSENSI", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEABSENSI",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataTypeabsensi = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_TYPEABSENSI" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type attendence has been deleted");
          return dispatch(actGetDataTypeabsensi());
        }
        return dispatch({ type: "ERROR_TYPEABSENSI", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEABSENSI",
          message: "Network error..",
        });
      });
  };
};
